module.exports = __webpack_public_path__ + "static/assets/e7e2824c7f24cea27365911ff8678e03.svg";